import React from 'react'
import { Link } from 'react-router-dom'
import styles from './AllChallans.module.css'

const AllChallans = () => {
    return (
        <div>
            AllChallans
            <Link to="/challans/generate">Generate Challan</Link>
            
        </div>
    )
}

export default AllChallans